import React from 'react';
import styled from 'styled-components';

const ErrorContainerStyled = ({ className, title, description }) => {
  return (
    <div className={className}>
      <div className="title">{title}</div>
      <div className="description">{description}</div>
    </div>
  );
};

export default styled(ErrorContainerStyled)`
  width: 100%;
  text-align: center;
  border-radius: 0.4rem;
  background-color: var(--error100);
  padding: 1.6rem;

  .title {
    color: var(--grey900);
    font-weight: bold;
  }

  .description {
    color: var(--grey900);
    margin-top: 0.8rem;
  }
`;
